import $ from 'jquery';
import ko from 'knockout';

/**
* visibleWhen custom binding
*/
ko.bindingHandlers.visibleWhen = {
    init: function(element, valueAccessor) {
        const value = ko.unwrap(valueAccessor());
        const $elem = $(element);

        if (typeof value === "boolean") {
            $elem.toggle(value);
        } else if (typeof value === "string") {
            let $target = $(value);
            if ($target.length) {
                var target = $target[0];

                ko.utils.registerEventHandler(target, "keyup", () => {
                    if ($(this).attr("type") === "checkbox") {
                        $elem.toggle($(this).attr("checked") === "checked");
                    } else {
                        $elem.toggle($(this).val().length > 0);
                    }
                });
            }

            //if (item.attr("type") === "checkbox") {
            //    $elem.toggle(item.attr("checked") === "checked");
            //} else {
            //    $elem.toggle(item.val().length > 0);
            //}
        }
    }
};